import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {
    EmployeeRequestDetailsDesktopComponent
} from '@employee-pages/badge-request-page/employee-request-details/desktop/employee-request-details-desktop.component';
import {RequestReason} from '@employee-pages/badge-request-page/employee-badge-requests';
import {UserRuleReader} from '@ui-app/services/user-rules-reader.service';
import {Observable} from 'rxjs';
import * as EmployeeModels from '@employee-models/index';
import {UsersService} from 'DBadgeEmployee-app/src/app/core/services/data-access/users.service';
import { IPPMDSearchInMyLocationResult } from '@employee-models/data.models';

@Component({
    selector: 'employee-request-details-desktop-onbehalf',
    templateUrl: './onbehalf-request-details-desktop.component.html',
    styleUrls: ['./onbehalf-request-details-desktop.component.less']
})

export class OnBehalfRequestDetailsDesktopComponent extends EmployeeRequestDetailsDesktopComponent implements OnChanges {
    @Input() tabs: Array<RequestReason>;
    @Input() visitorsTabs: RequestReason[];
    @Output() onUserChange = new EventEmitter<any>();

    userType: 'employee' | 'contractor' = 'employee';
    selectedUserEmailAddress: string = '';
    selectedUserDeliveryFacilityName: string = '';
    disableTabs: boolean = true;
    disableVisitorsTabs: boolean = true;
    selectedUserRoleId: number;
    userCountry = sessionStorage.getItem('userCountry');
    canUpload: boolean = false;
    
    

    lookupEmployee$ = (searchText: string) => this.usersService.searchPerson(searchText, 'employee');
    lookupContractor$ = (searchText: string) => this.usersService.searchPerson(searchText, 'contractor');
    
    constructor(private usersService: UsersService, protected userRuleReader: UserRuleReader) {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
            if (changes.requestData && changes.requestData.currentValue) {
                this.disableTabs = !this.requestData.canUploadBadgeRequest || !this.selectedUserEmailAddress;
                this.disableVisitorsTabs = !this.requestData.canUploadVisitorBadgeRequest || !this.selectedUserEmailAddress;
                this.selectedUserRoleId =   this.userRuleReader.modifyUserRoleByCountry(this.requestData.roleId, this.userCountry);
                this.canUpload = this.requestData.canUploadBadgeRequest;
            }
            if (changes.tabs && changes.tabs.currentValue) {
                this.tabs = changes.tabs.currentValue;
            }
            if (changes.visitorsTabs && changes.visitorsTabs.currentValue) {
                this.visitorsTabs = changes.visitorsTabs.currentValue.filter(tab => tab.categoryId !== 8);
            }
        }
    

    userTypeChanged(type: 'employee' | 'contractor'): void {
        this.userType = type;
        this.userChanged(null); // Clear selected user when type changes
    }

    userChanged(user: any): void {
        if (user) {
            this.selectedUserEmailAddress = user.email || '';
            this.selectedUserDeliveryFacilityName = user.facilityName || '';
            this.selectedUserRoleId = user.roleId || 0;
        } else {
            this.clearUserData();
        }
        this.disableTabs = !this.requestData.canUploadBadgeRequest || !this.selectedUserEmailAddress;
        this.canUpload = true;
        // Emit the same event as PPMD for consistency
        this.disableVisitorsTabs = !this.requestData.canUploadVisitorBadgeRequest || !this.selectedUserEmailAddress;
        this.onUserChange.emit(user);
    }

    private clearUserData(): void {
        this.selectedUserEmailAddress = '';
        this.selectedUserDeliveryFacilityName = '';
        this.selectedUserRoleId = 0;
    }
}